


import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getUsersApi } from "../../apis/userApi";

export const useUsers = (
  filters,
  currentPage,
  entriesPerPage,
  currentUser,
  enabled = true
) => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to load users.",
    };
  };

  const fetchUsers = useCallback(
    async (silent = false) => {
      if (!enabled) return;

      setLoading(true);
      setError(null);

      let toastId = null;
      if (!silent) {
        toastId = toast.loading("Loading users...");
      }

      try {
        const params = {
          search: filters.search || undefined,
          role: filters.group__name || undefined,
          is_active: filters.is_active || undefined,
          page: currentPage,
          page_size: entriesPerPage,
        };

        const { users: fetchedUsers, pagination: fetchedPagination } =
          await getUsersApi(params, currentUser);

        setUsers(fetchedUsers);
        setPagination(fetchedPagination);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>Users Loaded</strong>
                <div>Users loaded successfully.</div>
              </div>
            ),
            type: "success",
            isLoading: false,
            autoClose: 1500,
          });
        }
      } catch (err) {
        const { title, issue } = extractError(err);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>{title}</strong>
                <div>{issue}</div>
              </div>
            ),
            type: "error",
            isLoading: false,
          });
        } else {
          toast.error(
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          );
        }

        setError({ title, issue });
      } finally {
        setLoading(false);
      }
    },
    [filters, currentPage, entriesPerPage, currentUser, enabled]
  );

  useEffect(() => {
    fetchUsers(true);
  }, [fetchUsers]);

  return {
    users,
    pagination,
    loading,
    error,
    refetch: () => fetchUsers(false),
  };
};